import { createContext } from 'react';
import type { AuthContextType } from '../../types/auth';

export const AuthContext = createContext<AuthContextType>({
  user: null,
  token: null,
  isLoading: true,
  login: async () => {},
  signup: async () => {},
  loginWithOAuth: async () => {},
  loginWithTokens: async () => {},
  logout: async () => {},
  clearAuthData: () => {},
  updateUser: async () => {},
  refreshUser: async () => {},
});
